import React, {FC, ReactElement, useMemo} from 'react';
import {PathRouteProps} from "react-router/lib/components";
import {Route, useMatch, useParams} from "react-router-dom";

type Props = (PathRouteProps) & {
    render: (params: any) => ReactElement
    path: string
}

export const useRouteWithParam = ({path, render, ...other}: Props) => {
    const match = useMatch(path);
    const element = useMemo(() => {
        if (match) {
            return render(match?.params)
        } else {
            return <></>
        }
    }, [match, render]);
    return <Route  {...other} path={path} element={element}/>
}

export const RouteWithParam: FC<Props> = (props): ReactElement => {
    const params = useParams();
    const element = useMemo(() => props.render(params), [props, params]);
    return <React.Fragment>
        <Route {...props} element={element}/>
    </React.Fragment>
};